// اندپوینت‌های تولید محتوا با هوش مصنوعی (AiController — api/ai)
const ai = {
  productDescription: 'ai/product-description',
  seo: 'ai/seo',
  categoryText: 'ai/category-text',
  article: 'ai/article',
  productImage: 'ai/product-image',
  // کاور مقاله — دومرحله‌ای: اول تولید و پیش‌نمایش، بعد تأیید و ثبت روی مقاله
  blogCover: 'ai/blog-cover',
  blogCoverApply: 'ai/blog-cover/apply',
}
export default ai
